import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-mobile",
  "use": "rt-portal-mobile-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-portal-mobile\"><defs><style type=\"text/css\"></style></defs><path d=\"M744 112H280c-35.3 0-64 28.7-64 64v672c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V176c0-35.3-28.7-64-64-64z m-8 728H288V184h448v656z\" p-id=\"2258\" fill=\"#A9C2E8\" /><path d=\"M446 688c0 36.5 29.5 66 66 66s66-29.5 66-66-29.5-66-66-66-66 29.5-66 66z\" p-id=\"2259\" fill=\"#A9C2E8\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/mobile.svg
// module id = 1324
// module chunks = 91